import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { add } from 'date-fns'
import { Typography } from '@mui/material'
import i18next from 'i18next'
import { formatValidity } from 'utils'

import StatusCoupon from 'packages/ui/ChipStatus'

export const AvailableSoonCoupon = ({ count, table }) => {
  const { t } = useTranslation()
  return (
    <StatusCoupon
      status={t('coupons.validity.available_x_days', { count })}
      color={'#1976D2'}
      bgcolor={'#E3F2FD'}
      fontSize={table ? 10 : 12}
      height={24}
      borderRadius={'50px'}
    />
  )
}

export const AvailableCoupon = ({ table = false }) => {
  const { t } = useTranslation()
  return (
    <StatusCoupon
      status={t('coupons.validity.available')}
      color={'#587F31'}
      bgcolor={'#E6F0D7'}
      fontSize={table ? 10 : 12}
      height={24}
      borderRadius={'50px'}
    />
  )
}

export const ExpiredCoupon = ({ table }) => {
  const { t } = useTranslation()
  return (
    <StatusCoupon
      status={t('coupons.validity.expired')}
      color={'#DC2626'}
      bgcolor={'#FEE2E2'}
      fontSize={table ? 10 : 12}
      height={24}
      borderRadius={'50px'}
    />
  )
}

export const UsedCoupon = ({ table }) => {
  const { t } = useTranslation()
  return (
    <StatusCoupon
      status={t('coupons.validity.used')}
      color={'#587F31'}
      bgcolor={'#E6F0D7'}
      fontSize={table ? 10 : 12}
      height={24}
      borderRadius={'50px'}
    />
  )
}

export const DesactivateCoupon = ({ table }) => {
  const { t } = useTranslation()
  return (
    <StatusCoupon
      status={t('coupons.validity.desactivate')}
      color={'#5D5D5D'}
      bgcolor={'#E7E7E7'}
      fontSize={table ? 10 : 12}
      height={24}
      borderRadius={'50px'}
    />
  )
}

export const Validity = ({ coupon }) => {
  const { t } = useTranslation()
  const dateAtNow = new Date(Date.now())
  const endsDate = useMemo(() => {
    return add(new Date(coupon.first_provisioning_date), {
      minutes: coupon?.validity_period
    })
  }, [coupon.first_provisioning_date, coupon?.validity_period])

  if (coupon.used && endsDate < dateAtNow) {
    return (
      <Typography color={'error.main'} variant={'subtitle1Card'}>
        {formatValidity(coupon.validity_period, t)[0]}
      </Typography>
    )
  }
  return <Typography variant={'subtitle1Card'}>{formatValidity(coupon.validity_period, t)[0]}</Typography>
}

export const PeriodUse = ({ coupon }) => {
  const { t } = useTranslation()
  const endsDate = useMemo(() => {
    return add(new Date(coupon.first_provisioning_date), {
      minutes: coupon?.validity_period
    })
  }, [coupon.first_provisioning_date, coupon?.validity_period])

  if (coupon.used && coupon.starts_at && coupon.ends_at && !coupon.expired) {
    return (
      <Typography variant={'subtitle1Card'}>
        {t('coupons.table.validity_col.from') + new Date(coupon.starts_at).toLocaleDateString(i18next.language)}
        <br />
        {t('coupons.table.validity_col.to') + endsDate.toLocaleDateString(i18next.language)}
      </Typography>
    )
  } else if (coupon.starts_at && coupon.ends_at && coupon.expired) {
    return (
      <Typography color={'error.main'} variant={'subtitle1Card'}>
        {t('coupons.table.validity_col.from') + new Date(coupon.starts_at).toLocaleDateString(i18next.language)}
        <br />
        {t('coupons.table.validity_col.to') + new Date(coupon.ends_at).toLocaleDateString(i18next.language)}
      </Typography>
    )
  } else if (coupon.starts_at && coupon.ends_at && !coupon.expired) {
    return (
      <>
        {t('coupons.table.validity_col.from') + new Date(coupon.starts_at).toLocaleDateString(i18next.language)}
        <br />
        {t('coupons.table.validity_col.to') + new Date(coupon.ends_at).toLocaleDateString(i18next.language)}
      </>
    )
  }
  return '-'
}

const FirstUse = ({ coupon }) => {
  const { t } = useTranslation()
  return (
    <Typography variant={'subtitle1Card'}>
      {coupon.first_provisioning_date
        ? new Date(coupon.first_provisioning_date).toLocaleDateString(i18next.language)
        : t('coupons.card.used.false')}
    </Typography>
  )
}

export default FirstUse
